import { createSlice } from "@reduxjs/toolkit";
 
 
const fabricReducer = createSlice({
  name: "fabric",
  initialState: { 
    fabricModal: false,   
    sizeModal:false,
    sublimationSizeModal:false,
    fabricLoading:false,
    sizeLoading:false,
    sizeData:{},
    fabricData:{},
    sizeSelectedList:[],
    fabricSelectedList:[],
    fabricDataLoading:false,
    sizeDataLoading:false,
    fabricDataError:false,
    sizeDataError:false,
    addonsModal:false,

  },

  reducers: {       
    setFabricModal(state, action) {      
      state.fabricModal = !state.fabricModal
    },
    setSizeModal(state, action) {      
      state.sizeModal = !state.sizeModal
    },
    setSublimationSizeModal(state, action) {      
      state.sublimationSizeModal = !state.sublimationSizeModal
    },    
    setSizeLoading(state, action) {      
      state.sizeLoading = !state.sizeLoading
    },
    setFabricLoading(state, action) {      
      state.fabricLoading = !state.fabricLoading
    }, 
    setSizeData(state,action){
      state.sizeData=action.payload
    },
    setFabricData(state,action){
      state.fabricData=action.payload
    },
    setFabricSelectedList(state,action){
      state.fabricSelectedList=action.payload
    },    
    setSizeSelectedList(state,action){
      state.sizeSelectedList=action.payload
    },
    setAddonsModal(state, action) {      
      state.addonsModal = !state.addonsModal
    },
  
  },
});

export const {
    setFabricModal,setSizeModal,setSizeLoading,setFabricLoading,
    setSizeData,setFabricData,setSizeSelectedList,setFabricSelectedList, 
    setSublimationSizeModal,setAddonsModal,
} = fabricReducer.actions;
export default fabricReducer.reducer;

 


